// extracted by mini-css-extract-plugin
export default {"tags":"c6ns32V8yFNTw53D4mdk"};